import { IAddToolBOM } from '../../models/forms/IToolBOM';

export const AddToolBOMInitialState: IAddToolBOM = {
  Id: -1,
  MaterialProductId: '',
  ToolModel: '',
  MaterialKatashiki1: '',
  Category: '',
  MaterialManufacturerCode: '',
  TecmibizCode: '',
};

export default AddToolBOMInitialState;
